import { createSignal } from 'solid-js';

export type RealtimeStatus =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'reconnecting'
  | 'disconnected'
  | 'failed';

export interface RealtimeMetrics {
  connectionId: string | null;
  lastConnectedAt: number | null;
  lastEventAt: number | null;
  lastEventTopic: string | null;
  lastError: string | null;
  eventCount: number;
  reconnectCount: number;
}

const initialMetrics: RealtimeMetrics = {
  connectionId: null,
  lastConnectedAt: null,
  lastEventAt: null,
  lastEventTopic: null,
  lastError: null,
  eventCount: 0,
  reconnectCount: 0,
};

const [status, setStatus] = createSignal<RealtimeStatus>('idle');
const [metrics, setMetrics] = createSignal<RealtimeMetrics>(initialMetrics);

export const realtimeStatus = status;
export const realtimeMetrics = metrics;

export const setRealtimeStatus = (next: RealtimeStatus): void => {
  setStatus(next);
};

export const recordRealtimeConnect = (connectionId: string | null): void => {
  setStatus('connected');
  setMetrics((m) => ({
    ...m,
    connectionId,
    lastConnectedAt: Date.now(),
    lastError: null,
  }));
};

export const recordRealtimeEvent = (topic: string): void => {
  setMetrics((m) => ({
    ...m,
    lastEventAt: Date.now(),
    lastEventTopic: topic,
    eventCount: m.eventCount + 1,
  }));
};

export const recordRealtimeReconnect = (): void => {
  setStatus('reconnecting');
  setMetrics((m) => ({ ...m, reconnectCount: m.reconnectCount + 1 }));
};

export const recordRealtimeError = (message: string | null): void => {
  setMetrics((m) => ({ ...m, lastError: message }));
};

export const resetRealtimeStatus = (): void => {
  setStatus('idle');
  setMetrics(initialMetrics);
};
